"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6c-3.312 0-6 2.688-6 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6zm0 1.8c.996 0 1.8.804 1.8 1.8s-.804 1.8-1.8 1.8-1.8-.804-1.8-1.8.804-1.8 1.8-1.8zm-3.6 6.588a4.32 4.32 0 007.2 0c-.018-1.194-2.406-1.848-3.6-1.848-1.2 0-3.582.654-3.6 1.848z" }), "Profile");
//# sourceMappingURL=Profile.js.map